import { useContext } from 'react';
import { TerritoryTabContext } from '../context/territoryTab';

export function useTerritoryActiveTab() {
  return useContext(TerritoryTabContext);
}
